module.exports = __webpack_public_path__ + "static/media/agalerija_2023 (33).ce6d5acd.png";